export class Troubleshooting {

    sn : number  = null;
    name : string = '';
    code : string = '';
    desc : string = '';
    cat : string = '';
    id : string = null;

    getSn(){
        return this.sn;
    }

    getName(){
        return this.name;
    }

    getCode(){
        return this.code;
    }

    getDesc(){
        return this.desc;
    }

    getId(){
        return this.id;
    }


    getCat(){
        return this.cat;
    }

    setSn(sn: number){
        this.sn = sn;
    }

    setName(name: string){
        this.name = name;
    }

    setCode(code: string){
        this.code = code;
    }

    setDesc(desc: string){
        this.desc = desc;
    }

    setId(id: string){
        this.id = id;
    }

    setCat(cat: string){
        this.cat = cat;
    }
}